import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { AuthService } from '../auth/services';

@Injectable({
  providedIn: 'root',
})
export class ApiClientService {
  private apiUrl: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.apiUrl = environment.apiUrl;
  }

  public getData(route: string) {
    return this.http.get(this.createCompleteRoute(route, this.apiUrl), this.generateHeaders());
  }

  public create(route: string, body) {
    return this.http.post(this.createCompleteRoute(route, this.apiUrl), body, this.generateHeaders());
  }

  public update(route: string, body) {
    return this.http.put(this.createCompleteRoute(route, this.apiUrl), body, this.generateHeaders());
  }

  public delete(route: string) {
    return this.http.delete(this.createCompleteRoute(route, this.apiUrl));
  }

  public uploadFile(formData: any) {
    const uploadReq = new HttpRequest(
      'POST',
      this.createCompleteRoute(`api/uploadfile/upload`, this.apiUrl),
      formData,
      {
        reportProgress: true,
      }
    );

    return this.http.request(uploadReq);
  }

  public deleteFile(body: any) {
    return this.http.put(this.createCompleteRoute(`api/uploadfile/delete`, this.apiUrl), body, this.generateHeaders());
  }

  private createCompleteRoute(route: string, envAddress: string) {
    return `${envAddress}${route}`;
  }

  private generateHeaders() {
    const _headers = { 'Content-Type': 'application/json' };

    if (this.authService.isAuthenticated) _headers['Authorization'] = 'Bearer ' + this.authService.getToken();

    return {
      headers: new HttpHeaders(_headers),
    };
  }
}
